import React from 'react';
import './Creditos.css';

const Creditos = () => {
    return(
        <div className="credit column nowrap centerContent">
            <div className="head column nowrap centerContent centerItens">
                <span className="colorEIC strokeText">
                    Créditos
                </span>
                <div className="highlights row nowrap spaceAroundContent ">
                    <img src="/app/infocovid19/images/layout/creditos/icon-cibfar.png" alt="CIBFar"/>
                    <img src="/app/infocovid19/images/layout/creditos/icon-fapesp.png" alt="FAPESP"/>
                    <img src="/app/infocovid19/images/layout/creditos/icon-cnpq.png" alt="CNPq"/>
                </div>
            </div>
            <div className="content row wrap spaceAroundContent">
                <div className="entity row nowrap shadow">
                    <div className="image">
                        <img  src="/app/infocovid19/images/layout/creditos/executive-w.png" alt="Participação"/>
                    </div>
                    <div className="text column nowrap" >
                        <div className="work"><span>Supervisão e Revisão Geral</span></div>
                        <div><span>Leila M. Beltramini</span></div>
                    </div>
                </div>
                <div className="entity row nowrap shadow">
                    <div className="image">
                        <img  src="/app/infocovid19/images/layout/creditos/executive-w.png" alt="Participação"/>
                    </div>
                    <div className="text column nowrap" >
                        <div className="work"><span>Coordenação e Supervisão</span></div>
                        <div><span>Leila M. Beltramini<br/>Nelma R. S. Bossolan</span></div>
                    </div>
                </div>
                <div className="entity row nowrap shadow">
                    <div className="image">
                        <img  src="/app/infocovid19/images/layout/creditos/programmer-w.png" alt="Participação"/>
                    </div>
                    <div className="text column nowrap" >
                        <div className="work"><span>Gerente de Projetos</span></div>
                        <div><span>Simone Souza</span></div>
                    </div>
                </div>
                <div className="entity row nowrap shadow">
                    <div className="image">
                        <img  src="/app/infocovid19/images/layout/creditos/teacher-w.png" alt="Participação"/>
                    </div>
                    <div className="text column nowrap" >
                        <div className="work"><span>Educadora</span></div>
                        <div><span>Gislaine Gomes da Costa</span></div>
                    </div>
                </div>
                <div className="entity row nowrap shadow">
                    <div className="image">
                        <img  src="/app/infocovid19/images/layout/creditos/programmer-w.png" alt="Participação"/>
                    </div>
                    <div className="text column nowrap" >
                        <div className="work"><span>Conteúdo</span></div>
                        <div><span>Jéssica Lana de Mattos<br/>Giovanna Costa Villefort</span></div>
                    </div>
                </div>
                <div className="entity row nowrap shadow">
                    <div className="image">
                        <img  src="/app/infocovid19/images/layout/creditos/programmer-w.png" alt="Participação"/>
                    </div>
                    <div className="text column nowrap" >
                        <div className="work"><span>Artes</span></div>
                        <div><span>Jéssica Lana de Mattos</span></div>
                    </div>
                </div>
                <div className="entity row nowrap shadow">
                    <div className="image">
                        <img  src="/app/infocovid19/images/layout/creditos/teacher-w.png" alt="Participação"/>
                    </div>
                    <div className="text column nowrap" >
                        <div className="work"><span>Revisão de Conteúdo</span></div>
                        <div><span>Gislaine Gomes da Costa<br/>Gabriel Picolo de Castro</span></div>
                    </div>
                </div>
                <div className="entity row nowrap shadow">
                    <div className="image">
                        <img  src="/app/infocovid19/images/layout/creditos/programmer-m.png" alt="Participação"/>
                    </div>
                    <div className="text column nowrap" >
                        <div className="work"><span>Desenvolvimento de Software</span></div>
                        <div><span>Giovanni W. da Costa</span></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Creditos;